import React from "react";
import ProfileListingPageLayout from "../components/ProfileListingPageLayout";
import Carousel from "../components/Carousel";
import carouselImages from "../data/carouselImages";
const NAM: React.FC = () => {
  const pageDescription = (
    <p className="opacity-70 mt-4 text-xl lg:text-xl">
      <b>
        Experience Unprecedented Amp Realism with Premium Neural Amp Modeler
        (NAM) Profiles.{" "}
      </b>
      Dive into our collection of meticulously trained NAM captures, delivering
      the authentic tones of legendary amplifiers. Start with our free Marshall
      and Kitty Hawk NAM profiles, and then explore our premium offerings,
      including the coveted SRV tone and the iconic Mesa Boogie Mark IIA.
      Discover the next level of amp modeling fidelity and bring the sound of
      your favorite amps to your digital setup with our high-quality NAM
      profiles.
    </p>
  );

  const namMetadataEditorSection = (
    <div className="container mx-auto px-8 pb-8 text-white max-w-[1280px]">
      <section className="opacity-70 text-xl lg:text-xl my-20 flex gap-4 flex-col text-center items-center">
        <h1 className=" text-xl md:text-2xl  lg:text-2xl font-bold gradient-text ">
          NAM Metadata Editor
        </h1>
        <p>
          For custom NAM file creators: Utilize this online editor to perform
          batch metadata and filename modifications efficiently.
        </p>
        <div className="flex justify-center">
          {" "}
          {/* Removed w-full */}
          <a
            href="/nam-editor/"
            target="_blank"
            aria-label="nam metadata editor"
            rel="noopener noreferrer"
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg text-nowrap"
          >
            Learn more
          </a>
        </div>
      </section>
    </div>
  );

  return (
    <>
      {" "}
      <Carousel images={carouselImages} className=" max-h-1/6" />{" "}
      <ProfileListingPageLayout
        pageTitle="NAM Models"
        pageDescription={pageDescription}
        profileTypeFilter="nam"
        titleGradientClass="gradient-text-tonex" // Assuming this gradient is desired for NAM page title too
      />
      {namMetadataEditorSection}
    </>
  );
};

export default NAM;
